<div class='UploadMoveDialog'>
  <ng-container *ngIf='state === states.SELECT_TEMPLATE'>
    <div [formGroup]='inputForm' class='select-template'>
      <div class='alert alert-info'>
        <p>V1 - if you know the email addresses only
          <app-button [Click]='downloadTemplateByEmailButton.onClick' [color]='downloadTemplateByEmailButton.color'
                      [size]='downloadTemplateByEmailButton.size'
                      [text]='downloadTemplateByEmailButton.text'></app-button>
        </p>
        <p>V2 - if you know the exact contact IDs
          <app-button [Click]='downloadTemplateByIdButton.onClick' [color]='downloadTemplateByIdButton.color'
                      [size]='downloadTemplateByIdButton.size'
                      [text]='downloadTemplateByIdButton.text'></app-button>
        </p>
      </div>
      <mat-radio-group
        class='select-template--radio-group'
        formControlName='template'>
        <mat-radio-button
          [value]='templates.V1'
          class='select-template--radio-button'
        >V1
        </mat-radio-button
        >
        <mat-radio-button
          [value]='templates.V2'
          class='select-template--radio-button'
        >V2
        </mat-radio-button
        >
      </mat-radio-group>
    </div>
  </ng-container>
</div>
